import cn from 'classnames';
import { useSelector } from 'react-redux';
import { rm } from 'utils';
import { isDesktopLayout } from 'components/Shared/responsive';
import { IconFacebook } from 'components/Shared/Icon/themes/PP/iconFacebook';
import { IconTwitter } from 'components/Shared/Icon/themes/PP/iconTwitter';
import { IconInstagram } from 'components/Shared/Icon/themes/PP/iconInstagram';
import { IconLinkedin } from 'components/Shared/Icon/themes/PP/iconLinkedin';
import { IconYoutube } from 'components/Shared/Icon/themes/PP/iconYoutube';
import styles from './social.scss';

interface Props {
  className?: string;
}

export const Social = ({ className }: Props) => {
  const isDesktop = useSelector(isDesktopLayout);
  const iconSize = isDesktop ? 'large' : 'xl';

  return (
    <div className={cn(styles.social, className)}>
      <h4 className={styles.title}>{rm('footer_social_heading')}</h4>
      <div className={styles.icons}>
        <a href={rm('url_footer_social_facebook')} target="_blank" rel="noreferrer noopener">
          <IconFacebook size={iconSize} />
        </a>
        <a href={rm('url_footer_social_twitter')} target="_blank" rel="noreferrer noopener">
          <IconTwitter size={iconSize} />
        </a>
        <a href={rm('url_footer_social_instagram')} target="_blank" rel="noreferrer noopener">
          <IconInstagram size={iconSize} />
        </a>
        <a href={rm('url_footer_social_linkedin')} target="_blank" rel="noreferrer noopener">
          <IconLinkedin size={iconSize} />
        </a>
        <a href={rm('url_footer_social_youtube')} target="_blank" rel="noreferrer noopener">
          <IconYoutube size={iconSize} />
        </a>
      </div>
    </div>
  );
};
